export default __webpack_public_path__ + "static/Cover-2cabdbae4e89939dbeb2bd65469a8f6a.jpg";